import { get } from 'epics/ajax';
import { contextPath } from '@atlassian/help-center-common-util/history';
import type { RequestSmartCardResponse } from './types';

export const canViewRequest = (requestKey: string, context: string = contextPath): Promise<boolean> => {
    const uri = `${context}/rest/servicedesk/1/customer/${requestKey}/smartcard/canviewrequest`;

    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return get(uri)
        .map((ajaxResponse) => {
            // Suppressing existing violation. Please fix this.
            // eslint-disable-next-line @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-member-access
            return ajaxResponse.response.canViewRequest;
        })
        .toPromise()
        .catch((e) => Promise.reject(e));
};

export const getRequestSmartCardData = (
    requestKey: string,
    context: string = contextPath
): Promise<RequestSmartCardResponse> => {
    const uri = `${context}/rest/servicedesk/1/customer/${requestKey}/smartcard`;

    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return get(uri)
        .map((ajaxResponse) => {
            // Suppressing existing violation. Please fix this.
            // eslint-disable-next-line @typescript-eslint/no-unsafe-return
            return ajaxResponse.response;
        })
        .toPromise()
        .catch((e) => Promise.reject(e));
};
